<section class="mask-curve-top bg-gray-light pb-9 pt-16">
  <div class="centered-with-padding">
    <div class="pb-6">
      <app-title [title]="{ text: data.title, as: 'span' }" size="h2" />
    </div>
    <div class="grid grid-cols-1 gap-x-3 pb-8 desk:grid-cols-2 desk:pb-6">
      @for (testimony of testimonies(); track $index) {
        @if ($index !== 1 || isDesktop()) {
          <div
            [routerLink]="testimony.url"
            class="group relative h-[370px] cursor-pointer overflow-hidden rounded-2xl text-white desk:block">
            <div class="absolute -z-10 size-full">
              <app-image
                [hoverEffect]="true"
                [image]="testimony.image"
                [isPriority]="!isImageInPreviousBlocks && $index < 2"
                [pregenerationSize]="{ width: 534, height: 370 }" />
            </div>
            <div class="flex size-full flex-col justify-end p-5">
              <div class="pb-3">
                <app-svg [height]="50" [width]="64" class="opacity-60 invert" src="assets/icons/quote.svg" />
              </div>
              <div [innerHTML]="testimony.text" class="pb-1 text-[14px] leading-[17px]"></div>
              <div class="flex items-center gap-2">
                <span class="font-bold italic">{{ testimony.author }}</span>
                <app-svg
                  [height]="9"
                  [inline]="true"
                  [width]="14"
                  class="text-white"
                  src="assets/icons/arrow-right.svg" />
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
  <div class="mx-auto w-fit">
    <app-button [label]="data.cta.label" [url]="data.cta.url" />
  </div>
</section>
